import { notifications } from '@mantine/notifications';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Interval, Resource } from '@/types/types';

interface MoveIntervalParams {
  intervalId: Interval['id'];
  newResourceableId: Resource['resourceable_id'];
}

const useMoveInterval = ({ resource }: { resource: Resource }) => {
  const { axiosInstance } = useApi();

  const { id, project_id } = resource;

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ intervalId, newResourceableId }: MoveIntervalParams) => {
      const { data } = await axiosInstance.post<{
        message: string;
        resource: Resource;
      }>(
        '/api/v1/resources/move_interval',
        {},
        {
          params: {
            interval_id: intervalId,
            new_resourceable_id: newResourceableId,
            id,
            project_id,
          },
        }
      );
      return data;
    },

    onSuccess: () => {
      // Invalidate all related queries
      queryClient.invalidateQueries({
        queryKey: queryKeys.planningProjects._def,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.resources._def,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.projects._def,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.intervals._def,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tasks._def,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.resources.byGrouped._def,
      });

      notifications.show({
        title: 'Succes',
        message: 'Interval blev flyttet',
        color: 'green',
      });
    },
    onError: () => {
      notifications.show({
        title: 'Fejl',
        message: 'Kunne ikke flytte interval',
        color: 'red',
      });
    },
  });
};

export default useMoveInterval;
